import { isValidElement, ReactNode } from 'react';
import { message } from 'antd';
import { createStore } from 'luffie';
import { IErroApp, IErroStore } from '../interfaces/IErro';

const MAX_ERROS = 100;

const initialData: IErroStore = {
  erros: [],
  isModalOpen: false,
};

const { state$, updateState, getCurrentState } = createStore(initialData);

const extractFromNode = (node: ReactNode): string => {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) {
    return node.map(extractFromNode).filter(Boolean).join(' ');
  }
  if (isValidElement(node)) {
    return extractFromNode((node.props as { children?: ReactNode }).children);
  }
  return '';
};

const extractErrorText = (content: unknown): string => {
  if (content == null) return '';
  if (typeof content === 'string' || typeof content === 'number') {
    return String(content).trim();
  }
  if (typeof content === 'object' && content !== null && 'content' in content) {
    return extractErrorText((content as { content: unknown }).content);
  }
  return extractFromNode(content as ReactNode).trim();
};

const addErro = (mensagem: string) => {
  const texto = (mensagem || '').trim();
  if (!texto) return;

  const { erros } = getCurrentState();
  const novo: IErroApp = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    mensagem: texto,
    ocorridoEm: new Date().toISOString(),
  };

  updateState({
    erros: [novo, ...erros].slice(0, MAX_ERROS),
  });
};

const openErroModal = () => {
  updateState({ isModalOpen: true });
};

const closeErroModal = () => {
  updateState({ isModalOpen: false });
};

const clearErros = () => {
  updateState({
    erros: [],
    isModalOpen: false,
  });
};

type MessageErrorFn = typeof message.error & { __hidrozapOriginal?: typeof message.error };

const currentError = message.error as MessageErrorFn;
const originalMessageError = (currentError.__hidrozapOriginal ?? currentError).bind(message);

const patchedMessageError = ((content: unknown, duration?: unknown, onClose?: unknown) => {
  const texto = extractErrorText(content);
  if (texto) addErro(texto);
  return originalMessageError(content as never, duration as never, onClose as never);
}) as MessageErrorFn;

patchedMessageError.__hidrozapOriginal = currentError.__hidrozapOriginal ?? originalMessageError;
message.error = patchedMessageError;

export {
  state$ as erroState,
  addErro,
  openErroModal,
  closeErroModal,
  clearErros,
};
